<template>
  <div>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.第二次收縮壓"
      label="第二次收縮壓"
      max="300"
      :option="{ suffix: 'mmHg', integer: true }"
    ></d-input>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.第二次舒張壓"
      label="第二次舒張壓"
      max="300"
      :option="{ suffix: 'mmHg', integer: true }"
    ></d-input>

    <v-btn block x-large class="mt-4 text-h6" color="success" @click="submit"
      >送出</v-btn
    >
    <v-btn block x-large class="mt-8 text-h6" color="error" @click="back"
      >取消</v-btn
    >
  </div>
</template>

<script>
import station from "@/mixins/station";
export default {
  mixins: [station],
  data: () => ({
    payload: {
      第二次舒張壓: null,
      第二次收縮壓: null,
    },
  }),
};
</script>

<style lang="scss" scoped>
</style>